import { styled, Typography } from '@mui/material'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
import Logo from '../../../svg/Logo'
import NotFoundIcon from '../../../svg/NotFound'
import ViewTitle from '../../../components/ViewTitle'

const Wrapper = styled('div')(() => ({
  marginTop: '48px',
  marginBottom: '48px',
  textAlign: 'center'
}))

const Splash = styled('div')(() => ({
  marginTop: '48px',
  marginBottom: '48px'
}))

export default function NotFound() {
  return (
    <Wrapper>
      <ViewTitle title="Page Not Found" />
      <Container maxWidth="sm">
        <Logo fill="#222" />
        <Splash>
          <NotFoundIcon width="100%" height="100%" />
        </Splash>
        <Typography variant="h4" gutterBottom>
          Page Not Found
        </Typography>
        <Typography>
          Sorry, there’s nothing here. Go to <Link href="/">Main Page</Link>
        </Typography>
      </Container>
    </Wrapper>
  )
}
